import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"

// Connects to data-controller="timezone-select"
export default class extends Controller {
  static targets = ["select"]

  connect() {
    new TomSelect(this.selectTarget, {
      plugins: ['dropdown_input'],
      placeholder: 'Select timezone...',
      searchField: ['text'],
      create: false,
      sortField: {
        field: "text",
        direction: "asc"
      }
    })
  }
}
